module.exports = __webpack_public_path__ + "static/media/patent-02.b313f21f.jpg";